<!--
* 组件名 : 背景图组件
* 开发者 : LH
*
* 参数:
* src        [Array, String]   required - 背景图信息, 可以为i18n字符串|i18n字符串数组|颜色值|i18n视频
* autoHeight [Boolean]         option   - 是否自适应图片高度
* slideUpIn  [Boolean]         option   - 是否执行 slide up in 效果 (与 v-slide-up-in 结合使用)
-->

<script>
import parallaxItem from "./components/parallaxItem/index";
import imgItem from "./components/imgItem/index";
import videoItem from "./components/videoItem/index";
import pureColor from "./components/pureColor/index";

function getTagBySrc(src) {
  if (!src) return;
  if (Array.isArray(src)) {
    return `parallaxItem`;
  } else if (/\.(gif|png|jpg|jpeg)/.test(src)) {
    return "imgItem";
  } else if (/\.(mp4|webm|mov)/.test(src)) {
    return `videoItem`;
  } else if (~src.indexOf("#")) {
    return `pureColor`;
  }
}

export default {
  name: "v-background",
  props: {
    src: [String, Array],
    autoHeight: {
      type: Boolean,
      default: false,
    },
    isUseI18n: {
      type: Boolean,
      default: true,
    },
    slideUpIn: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    imgItem,
    parallaxItem,
    videoItem,
    pureColor,
  },
  directives: {
    resolveZIndex: {
      inserted: (el) => {
        $(el)
          .siblings()
          .map((key, el) => {
            $(el).css("z-index") === "auto" && $(el).css("z-index", 2);
            $(el).css("position") === "static" &&
              $(el).css("position", "relative");
          });
      },
    },
  },
  provide() {
    return {
      isUseI18n: this.isUseI18n,
      autoHeight: this.autoHeight,
      slideUpIn: this.slideUpIn,
    };
  },
  render(createElement, context) {
    const tag = getTagBySrc(this.src);
    const attrs = {
      class: ["v-background"],
    };

    if (this.autoHeight) {
      attrs.class.push("auto-height");
    }

    return (
      <section {...{ ...attrs }} vResolveZIndex>
        {this.$slots.default ? this.$slots.default : <tag data={this.src} />}
      </section>
    );
  },
};
</script>

<style scoped>
.v-background {
  z-index: 1;
}
</style>
